/**
 * The inbox («Entradas»): surveys that arrived to be budgeted (API
 * `quotes/inbox/*`). Reads return `response.data` or null; actions return
 * `{ status, data }` so the page can tell a 409 from a 403.
 */
import { download, request, settled } from "./http";

class QuoteInboxService {
  /** `{ items, total, currentPage, perPage, counts }`; params: filter, q, page, per_page. */
  list(params) {
    return request("get", "inbox", { params });
  }

  /** `{ unclassified, review, in_progress, done, discarded, pending }` */
  count() {
    return request("get", "inbox/count");
  }

  get(id) {
    return request("get", `inbox/${id}`);
  }

  /** `{ blob, filename }` of an attachment, or null. */
  file(id, fileId) {
    return download("get", `inbox/${id}/files/${fileId}`);
  }

  /** `{ service_type_ids: [], remember?, owner_id? }` → 201 `{ survey, quotes }`; 409 already_classified. */
  classify(id, payload) {
    return settled("post", `inbox/${id}/classify`, { data: payload });
  }

  /** Asks the classifier (again): 202; 409 request_pending; 503 assistant_unavailable. */
  identify(id) {
    return settled("post", `inbox/${id}/identify`);
  }

  /** `{ reason: duplicate | no_budget | other, note? }`; 409 quotes_active. */
  discard(id, payload) {
    return settled("post", `inbox/${id}/discard`, { data: payload });
  }

  restore(id) {
    return settled("post", `inbox/${id}/restore`);
  }

  /** `{ owner_id }` (manage_inbox); 422 owner_unknown. */
  owner(id, ownerId) {
    return settled("post", `inbox/${id}/owner`, { data: { owner_id: ownerId } });
  }

  /** 204; 409 quotes_exist. */
  remove(id) {
    return settled("delete", `inbox/${id}`);
  }

  /** `[{ id, name }]` of active users, for the owner picker (manage_inbox). */
  searchOwners(term) {
    return request("get", "inbox/owners/search", { params: { term } });
  }
}

export default new QuoteInboxService();
